var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("b-overlay", {
        staticClass: "main-loading",
        attrs: {
          show: !_vm.localizationLoaded,
          rounded: "sm",
          "spinner-variant": "warning"
        },
        scopedSlots: _vm._u([
          {
            key: "overlay",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "loading-icon" },
                  [
                    _c("b-icon", {
                      attrs: {
                        icon: "three-dots",
                        animation: "cylon",
                        scale: "8",
                        variant: "warning"
                      }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "keep-alive",
        [
          _vm.$route.meta.keepAlive && _vm.localizationLoaded
            ? _c("router-view")
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      !_vm.$route.meta.keepAlive && _vm.localizationLoaded
        ? _c("router-view")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 